// =============================================================================
// useCanOpenPackhouseConfig — would the /config route let this person in?
//
// /config is mounted as gPack('config', …) in App.tsx: RequireTenantKind
// PACKHOUSE, then RequireModule('config'). Both answer a refusal with a silent
// bounce to Home, so a "Config → X" pointer is offered as a link only when
// BOTH would pass — the module half through useCanOpenModule (the route gate's
// own hasModule), the kind half here.
//
// null while either is still deciding: callers show the pointer as plain text
// until then, never a link that might bounce.
//
// The money lock is not consulted: Config is `money: 'incidental'` in MODULES,
// so MoneyGate never withholds it.
// =============================================================================

import { useCanOpenModule } from '@/hooks/useCanOpenModule'
import { useActiveTenant } from '@/lib/useActiveTenant'

export function useCanOpenPackhouseConfig(): boolean | null {
  const canOpenModule = useCanOpenModule('config')
  const { data: tenant, isPending } = useActiveTenant()
  if (canOpenModule === null || isPending) return null
  return canOpenModule && tenant?.kind === 'PACKHOUSE'
}
